export const SLOT_MACHINE_SPEED = 300
export const TIMER_INTERVAL = 100
